import gql from 'graphql-tag';
import fragments from '../fragments';

export default {
    setCampaignTags: gql`
        mutation SetCampaignTags($campaignID: String!, $tagIDs: [String!]!) {
            setCampaignTags(campaignID: $campaignID, tagIDs: $tagIDs) {
                _
            }
        }
    `,
};
